<template>
    <div id="item-ledger-entry-filter">
        <b-row>

            <b-col>
                <v-select :options="paginated" :filterable="false" @open="onOpen" @close="onClose" label="Description"
                    @search="(query) => (search = query)" v-model="selected" ref="select">

                    <template #option="{ Description }">
                        <!-- <div class="d-flex align-items-center">
                            <b-badge pill variant="success" v-if="Family == 'MEDICAMENT'" class="mr-50">
                                <span>{{ Family }}</span>
                            </b-badge>
                            <b-badge pill variant="primary" v-else-if="Family == 'PARA'" class="mr-50">
                                <span>{{ Family }}</span>
                            </b-badge>
                            <b-badge pill variant="warning" v-else-if="Family == 'ACCESSOIRE'" class="mr-50">
                                <span>{{ Family }}</span>
                            </b-badge>
                            <b-badge pill variant="secondary" class="mr-50" v-else>
                                <span>{{ Family }}</span>
                            </b-badge>
                            <span class="ml-auto" v-html="highlightSearchText(Description)"></span>
                            <div>
                                <a href="#" @click="viewSubstitutions(Description)">Substitutions</a>
                                <a href="#" @click="viewComplementaires(Description)">Complémentaires</a>
                            </div>
                        </div> -->

                        <div>
                            <span class="description" v-html="highlightSearchText(Description)"></span>
                            <!-- <span class="links">
                                <b-link href="#" class="font-weight-bold mr-1"
                                    style="border-bottom: 1px solid #6e6b7b; color: inherit;"
                                    @click.stop="viewSubstitutions(Description)">Substitutions</b-link>

                                <b-link href="#" class="font-weight-bold"
                                    style="border-bottom: 1px solid #6e6b7b; color: inherit;"
                                    @click.stop="viewComplementaires(Description)">Complémentaires</b-link>
                            </span> -->
                        </div>
                    </template>

                    <span slot="no-options" v-show="!(search.trim() == '' && allProducts.length != 0)">
                        <span v-if="search.trim() != ''">

                            <div class="d-flex justify-content-center" v-if="allProducts.length == 0">
                                <b-button variant="primary" disabled class="mr-1" size="sm">
                                    <b-spinner small type="grow" />
                                    chargement des articles en cours
                                    <b-spinner small type="grow" />
                                </b-button>
                            </div>

                            <div class="d-flex align-items-center" v-else>
                                Désolé, aucun article trouvé
                            </div>

                        </span>
                        <span v-else>
                            <div class="d-flex justify-content-center" v-if="allProducts.length == 0">
                                <b-button variant="primary" disabled class="mr-1" size="sm">
                                    <b-spinner small type="grow" />
                                    chargement des articles en cours
                                    <b-spinner small type="grow" />
                                </b-button>
                            </div>
                            <div v-else>Effectuer une recherche d'articles en se basant sur leur désignation.</div>
                        </span>
                    </span>

                    <template #list-footer>
                        <li v-show="hasNextPage && search.trim() != ''" ref="load" class="loader">
                            Chargement plus d'articles...
                        </li>
                    </template>
                </v-select>
            </b-col>
            <!-- <b-col></b-col>
            <b-col cols="8"> -->
            <!-- </b-col>
            <b-col></b-col> -->

        </b-row>
    </div>
</template>
<script>

import vSelect from 'vue-select'

export default {
    components: {
        vSelect
    },
    data() {
        return {
            selected: null,
            observer: null,
            limit: 10,
            search: '',
        }
    },
    computed: {
        filtered() {
            return this.$store.getters["app-portaldata/getProducts"].filter(item => item.Description.toLowerCase().indexOf(this.search.toLowerCase()) > -1)
                .sort((a, b) => {
                    const indexA = a.Description.toLowerCase().indexOf(this.search.toLowerCase());
                    const indexB = b.Description.toLowerCase().indexOf(this.search.toLowerCase());
                    if (indexA === indexB) {
                        return 0;
                    }
                    return indexA < indexB ? -1 : 1;
                });
        },
        allProducts() {
            return this.$store.getters["app-portaldata/getProducts"];
        },
        paginated() {
            if (this.search.trim() == "")
                return [];
            return this.filtered.slice(0, this.limit)
        },
        hasNextPage() {
            return this.paginated.length < this.filtered.length
        },
    },
    mounted() {
        /**
         * You could do this directly in data(), but since these docs
         * are server side rendered, IntersectionObserver doesn't exist
         * in that environment, so we need to do it in mounted() instead.
         */
        this.observer = new IntersectionObserver(this.infiniteScroll)
    },
    watch: {
        selected(val) {
            if (val) {
                this.$emit("productClicked", val);
                this.search = "";
                this.selected = null;
            }
        }
    },
    created() {
        this.$nextTick(() => {
            this.$refs["select"].$el.querySelector("input").focus();
        });
    },
    methods: {
        viewSubstitutions(description) {
            console.log(description);
        },
        highlightSearchText(text) {
            const regex = new RegExp(this.search, 'gi');
            return text.replace(regex, match => `<b>${match}</b>`);
        },
        async onOpen() {
            // console.log("onOpen");
            if (this.hasNextPage) {
                await this.$nextTick()
                this.observer.observe(this.$refs.load)
            }
        },
        onClose() {
            // console.log("onClose");
            this.observer.disconnect();
            this.limit = 10;
        },
        async infiniteScroll([{ isIntersecting, target }]) {
            // console.log("infiniteScroll");
            if (isIntersecting) {
                const ul = target.offsetParent
                const scrollTop = target.offsetParent.scrollTop
                this.limit += this.limit
                await this.$nextTick()
                ul.scrollTop = scrollTop
            }
        },
    },
}
</script>
<style lang="scss">
.loader {
    text-align: center;
    color: #bbbbbb;
}

.description {
    display: inline-block;
    width: 70%;
}

.links {
    display: inline-block;
    width: 30%;
    text-align: right;
}
</style>